import Modal from 'components/ui/Modal'
import Tooltip from '@mui/material/Tooltip';
import React from 'react'

const DetailModal = ({ open, handleClose, data }) => {
    const { priority, remarks, stampInstruction, deliveryDate, clientName, bookType, orderNumber, createdAt, certificate, purchausOrder } = data;

    const catalogClientName = data?.client?.clientName;

    function formatDateOnly(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            timeZone: "Asia/Kolkata"
        });
    }
    function formatDateWithSuffix(dateString) {
        const date = new Date(dateString);

        const day = date.getDate();
        const month = date.toLocaleString("en-GB", { month: "short", timeZone: "Asia/Kolkata" });
        const year = date.getFullYear();

        // Add ordinal suffix to the day
        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return `${n}th`;
            switch (n % 10) {
                case 1: return `${n}st`;
                case 2: return `${n}nd`;
                case 3: return `${n}rd`;
                default: return `${n}th`;
            }
        };

        return `${getOrdinal(day)} ${month}, ${year}`;
    }
    return (
        <Modal open={open} handleClose={handleClose} style={{ width: "31.8vw" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #000000", paddingBottom: "0.6vw" }}>
                    <div style={{ fontFamily: "Poppins", fontSize: "1vw", fontWeight: 500 }}>
                        <style>
                            {`
                                .custom-tooltip-arrow-shadow::before {
                                    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
                                    background-color: white;
                                }
                            `}
                        </style>
                        <Tooltip title={clientName || catalogClientName} placement='bottom-start' arrow
                            PopperProps={{
                                modifiers: [
                                    {
                                        name: 'offset',
                                        options: {
                                            offset: [0, -8],
                                        },
                                    },
                                ],
                            }}
                            slotProps={{
                                arrow: {
                                    className: "custom-tooltip-arrow-shadow",
                                },
                            }}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: "white",
                                        color: "#101010",
                                        fontFamily: "Poppins",
                                        fontSize: "0.75vw",
                                        fontWeight: 500,
                                        borderRadius: ".25vw",
                                        padding: ".4vw .6vw",
                                        letterSpacing: "-0.41px",
                                        lineHeight: "120%",
                                        maxWidth: "18vw",
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                        boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.25)",
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: "white",
                                    },
                                },
                            }}
                        >
                            {catalogClientName ?
                                <span>{catalogClientName?.length > 16 ? `${catalogClientName?.slice(0, 16)}...` : catalogClientName} </span>
                                :
                                <span>{clientName?.length > 16 ? `${clientName?.slice(0, 16)}...` : clientName} </span>}
                        </Tooltip>
                        <span>{orderNumber} details</span>
                    </div>
                    <div style={{ fontFamily: "Poppins", fontSize: "1vw", fontWeight: 500 }}>
                        {formatDateOnly(createdAt)}
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                        <div style={{ color: '#4D4D4D', fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8vw" }}>P.O. NO.</div>
                        <div style={{ backgroundColor: "#EDEDEB", padding: "0.8vw", minWidth: "9.55vw", borderRadius: "0.5vw", fontFamily: "Poppins", fontWeight: 400, fontSize: "0.8vw", color: '#101010' }}>{purchausOrder || "-"}</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                        <div style={{ color: '#4D4D4D', fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8vw" }}>Certification</div>
                        <div style={{ backgroundColor: "#EDEDEB", padding: "0.8vw", minWidth: "9.55vw", borderRadius: "0.5vw", fontFamily: "Poppins", fontWeight: 400, fontSize: "0.8vw", color: '#101010' }}>{certificate || "-"}</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                        <div style={{ color: '#4D4D4D', fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8vw" }}>Priority</div>
                        <div style={{ backgroundColor: "#EDEDEB", padding: "0.8vw", minWidth: "9.55vw", borderRadius: "0.5vw", fontFamily: "Poppins", fontWeight: 400, fontSize: "0.8vw", color: '#101010' }}>{priority ? priority : "-"}</div>
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "0.8vw" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                        <div style={{ color: '#4D4D4D', fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8vw" }}>Book type</div>
                        <div style={{ backgroundColor: "#EDEDEB", padding: "0.8vw", minWidth: "9.55vw", borderRadius: "0.5vw", fontFamily: "Poppins", fontWeight: 400, fontSize: "0.8vw", color: '#101010' }}>{bookType || "-"}</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                        <div style={{ color: '#4D4D4D', fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8vw" }}>Delivery date</div>
                        <div style={{ backgroundColor: "#EDEDEB", padding: "0.8vw", minWidth: "9.55vw", borderRadius: "0.5vw", fontFamily: "Poppins", fontWeight: 400, fontSize: "0.8vw", color: '#101010' }}>{deliveryDate ? formatDateWithSuffix(deliveryDate) : "-"}</div>
                    </div>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                    <div style={{ color: '#4D4D4D', fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8vw" }}>Stamp Instruction</div>
                    <div style={{ backgroundColor: "#EDEDEB", padding: "0.8vw", minWidth: "9.55vw", borderRadius: "0.5vw", fontFamily: "Poppins", fontWeight: 400, fontSize: "0.8vw", color: '#101010' }}>{stampInstruction ? stampInstruction : "NA"}</div>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "0.6vw" }}>
                    <div style={{ color: '#4D4D4D', fontFamily: "Poppins", fontWeight: 600, fontSize: "0.8vw" }}>Remarks</div>
                    <div style={{ backgroundColor: "#EDEDEB", padding: "0.8vw", minWidth: "9.55vw", borderRadius: "0.5vw", fontFamily: "Poppins", fontWeight: 400, fontSize: "0.8vw", color: '#101010' }}>{remarks ? remarks : "NA"}</div>
                </div>

            </div>

        </Modal>
    )
}

export default DetailModal